var _defs, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlay = function SvgPlay(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "play_svg__Layer_1",
    width: 40,
    height: 40,
    strokeWidth: 1.5,
    color: "#24053b",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    role: "presentation"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-6374f543b67f094e4896c5e6-1{fill:none;stroke:currentColor;stroke-miterlimit:10}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10.5,
    className: "cls-6374f543b67f094e4896c5e6-1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m17.73 12-8.59 4.77V7.23z",
    className: "cls-6374f543b67f094e4896c5e6-1"
  })));
};
export default SvgPlay;